"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const Message_1 = __importDefault(require("../Message"));
const styles_1 = __importDefault(require("./styles"));
const Conversation = ({ fade = true, messages, style, theme = 'dark', }) => {
    const classes = styles_1.default({ fade });
    const containerRef = react_1.useRef();
    react_1.useEffect(() => {
        if (!containerRef.current) {
            return;
        }
        containerRef.current.scrollTo({
            top: containerRef.current.scrollHeight,
            behavior: 'smooth',
        });
    }, [messages]);
    return (react_1.default.createElement(core_1.Grid, { ref: containerRef, container: true, direction: "column", className: classes.container, style: style, spacing: 2 }, messages.map((message) => {
        return (react_1.default.createElement(core_1.Grid, { item: true, container: true, direction: "column", key: message.id },
            react_1.default.createElement(Message_1.default, { author: message.author, timestamp: message.createTime, direction: message.direction, text: message.text, theme: theme })));
    })));
};
exports.default = Conversation;
